import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import {
  studyLineChartReducer,
  mapDispatchToProps,
  mapStateToProps,
} from "./StudyLineChart.store";
import StudyLineChart from "../../library/StudyLineChart/StudyLineChart";
import { sendNotification } from "../../ToastManager/ToastManager";
import { ToastType } from "../../ToastManager/constants";
import moment from "moment";

export const SmartStudyLineChart = (props) => {
  const {
    dateRange: { startDate = null, endDate = null } = {},
    participantId,
    fetchLineChartData,
    entries,
    totalItems,
    update,
  } = props;

  const [hideScrollbar, setHideScrollBar] = useState(false);

  const validDateString = (date) => {
    switch (date) {
      case null:
        return false;
      case "Invalid date":
        return false;
      default:
        return true;
    }
  };

  const getData = useCallback(() => {
    fetchLineChartData(startDate, endDate, participantId).catch((error) => {
      sendNotification(error, ToastType.ERROR);
    });
  }, [fetchLineChartData, startDate, endDate, participantId]);

  useEffect(() => {
    if (validDateString(startDate) && validDateString(endDate)) {
      getData();
    }
  }, [endDate, getData, startDate, totalItems]);

  useEffect(() => {
    if (update) {
      getData();
    }
  }, [getData, update]);

  useEffect(() => {
    if (screen?.orientation?.type?.startsWith("landscape")) {
      const start = moment(startDate).startOf("day");
      const end = moment(endDate).endOf("day");

      if (start && end) {
        const days = Math.ceil(moment.duration(end.diff(start)).asDays());
        setHideScrollBar(days <= 11);
      }
    }
  }, [startDate, endDate]);

  return <StudyLineChart {...{ entries }} hideScrollbar={hideScrollbar} />;
};

export default dynamic(
  "studyLineChartReducer",
  subspaced({
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(studyLineChartReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartStudyLineChart));
